import React from 'react';

class KioskDelete extends React.Component {
  render() {
    let { onCancel, onDone, selectedHostInfoList } = this.props;
    return (
      <div style={{ width: 600 }}>
        <h1>Archive {selectedHostInfoList.length} Selected Kiosks</h1>
        <div className='pure-g' style={{ marginBottom: 20, fontSize: 18 }}>
          This will moved selected kiosks (hostinfo) into InactiveHostInfo table!
        </div>

        <div className='modalFooter pure-g' style={{ textAlign: 'right' }}>
          <div className='pure-u-5-24'></div>
          <div className='pure-u-1-4'>
            <button className='pure-button button-regular button-aux' onClick={onCancel}>
              Cancel
            </button>
          </div>
          <div className='pure-u-1-24'></div>
          <div className='pure-u-1-2'>
            <button className='pure-button button-regular button-accent' onClick={onDone}>
              Archive
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskDelete;



// WEBPACK FOOTER //
// ./src/components/KioskDelete.js